"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StatusView = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _initialState = _interopRequireDefault(require("./initialState"));

var _statusModule = _interopRequireDefault(require("./status.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StatusView = function StatusView(_ref) {
  var className = _ref.className,
      states = _ref.states,
      hasPermissions = _ref.hasPermissions,
      hideReset = _ref.hideReset,
      onReset = _ref.onReset,
      onSelect = _ref.onSelect;
  var intl = (0, _nicbaseTranslation.useIntl)();
  var NO_GPS = states.NO_GPS,
      COUPLED = states.COUPLED,
      NOT_COUPLED = states.NOT_COUPLED,
      DRIVING = states.DRIVING,
      STANDING = states.STANDING,
      LOADED = states.LOADED,
      NOT_LOADED = states.NOT_LOADED,
      DOOR_1_OPEN = states.DOOR_1_OPEN,
      DOOR_1_CLOSED = states.DOOR_1_CLOSED,
      DOOR_2_OPEN = states.DOOR_2_OPEN,
      DOOR_2_CLOSED = states.DOOR_2_CLOSED,
      DOOR_3_OPEN = states.DOOR_3_OPEN,
      DOOR_3_CLOSED = states.DOOR_3_CLOSED,
      REEFER_ON = states.REEFER_ON,
      REEFER_OFF = states.REEFER_OFF,
      NO_FUEL_RESERVE = states.NO_FUEL_RESERVE,
      FUEL_RESERVE = states.FUEL_RESERVE,
      CARRIER_ALERT = states.CARRIER_ALERT,
      CBT_ALERT = states.CBT_ALERT,
      TK_ALERT = states.TK_ALERT,
      CARRIER_CAUTION = states.CARRIER_CAUTION,
      CBT_CAUTION = states.CBT_CAUTION,
      TK_CAUTION = states.TK_CAUTION,
      CARRIER_NOTIFICATION = states.CARRIER_NOTIFICATION,
      CBT_NOTIFICATION = states.CBT_NOTIFICATION,
      TK_NOTIFICATION = states.TK_NOTIFICATION,
      DTC_ALARM = states.DTC_ALARM,
      DTC_CAUTION = states.DTC_CAUTION,
      DTC_NOTIFICATION = states.DTC_NOTIFICATION;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('overflow-auto p-2 flex flex-col', className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.misc"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h2", {
      className: "font-bold py-4 m-0"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.gps'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('NO_GPS')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, NO_GPS)),
      onClick: function onClick() {
        return onSelect({
          NO_GPS: !NO_GPS
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "NO_GPS",
      className: "w-6 h-6"
    }));
  })), hasPermissions(['module.filter.status.coupled']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.coupledState'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('COUPLED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, COUPLED)),
      onClick: function onClick() {
        return onSelect({
          COUPLED: !COUPLED,
          NOT_COUPLED: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "COUPLED",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('NOT_COUPLED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, NOT_COUPLED)),
      onClick: function onClick() {
        return onSelect({
          NOT_COUPLED: !NOT_COUPLED,
          COUPLED: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "NOT_COUPLED",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.movingState'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DRIVING')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DRIVING)),
      onClick: function onClick() {
        return onSelect({
          DRIVING: !DRIVING,
          STANDING: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Driving, {
      status: "DRIVING",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('STANDING')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, STANDING)),
      onClick: function onClick() {
        return onSelect({
          STANDING: !STANDING,
          DRIVING: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Standing, {
      status: "STANDING",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.ebsLoadCondition'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('LOADED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, LOADED)),
      onClick: function onClick() {
        return onSelect({
          LOADED: !LOADED,
          NOT_LOADED: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "LOADED",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('NOT_LOADED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, NOT_LOADED)),
      onClick: function onClick() {
        return onSelect({
          NOT_LOADED: !NOT_LOADED,
          LOADED: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "NOT_LOADED",
      className: "w-6 h-6"
    }));
  }))), hasPermissions(['module.filter.status.door']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.doorStates"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h2", {
      className: "font-bold py-4 m-0"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.door'
  }, {
    number: 1
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_1_OPEN')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DOOR_1_OPEN)),
      onClick: function onClick() {
        return onSelect({
          DOOR_1_OPEN: !DOOR_1_OPEN,
          DOOR_1_CLOSED: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_1_OPEN",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_1_CLOSED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DOOR_1_CLOSED)),
      onClick: function onClick() {
        return onSelect({
          DOOR_1_CLOSED: !DOOR_1_CLOSED,
          DOOR_1_OPEN: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_1_CLOSED",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.door'
  }, {
    number: 2
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_2_OPEN')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DOOR_2_OPEN)),
      onClick: function onClick() {
        return onSelect({
          DOOR_2_OPEN: !DOOR_2_OPEN,
          DOOR_2_CLOSED: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_2_OPEN",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_2_CLOSED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DOOR_2_CLOSED)),
      onClick: function onClick() {
        return onSelect({
          DOOR_2_CLOSED: !DOOR_2_CLOSED,
          DOOR_2_OPEN: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_2_CLOSED",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.door'
  }, {
    number: 3
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_3_OPEN')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DOOR_3_OPEN)),
      onClick: function onClick() {
        return onSelect({
          DOOR_3_OPEN: !DOOR_3_OPEN,
          DOOR_3_CLOSED: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_3_OPEN",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_3_CLOSED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DOOR_3_CLOSED)),
      onClick: function onClick() {
        return onSelect({
          DOOR_3_CLOSED: !DOOR_3_CLOSED,
          DOOR_3_OPEN: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_3_CLOSED",
      className: "w-6 h-6"
    }));
  }))), hasPermissions(['module.filter.status.reefer']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.reeferStates"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h2", {
      className: "font-bold py-4 m-0"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.reeferState'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('REEFER_ON')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, REEFER_ON)),
      onClick: function onClick() {
        return onSelect({
          REEFER_ON: !REEFER_ON,
          REEFER_OFF: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "REEFER_ON",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('REEFER_OFF')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, REEFER_OFF)),
      onClick: function onClick() {
        return onSelect({
          REEFER_OFF: !REEFER_OFF,
          REEFER_ON: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "REEFER_OFF",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.fuelState'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('NO_FUEL_RESERVE')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, NO_FUEL_RESERVE)),
      onClick: function onClick() {
        return onSelect({
          NO_FUEL_RESERVE: !NO_FUEL_RESERVE,
          FUEL_RESERVE: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "NO_FUEL_RESERVE",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('FUEL_RESERVE')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, FUEL_RESERVE)),
      onClick: function onClick() {
        return onSelect({
          FUEL_RESERVE: !FUEL_RESERVE,
          NO_FUEL_RESERVE: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "FUEL_RESERVE",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.redErrorCodes'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CARRIER_ALERT')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, CARRIER_ALERT)),
      onClick: function onClick() {
        return onSelect({
          CARRIER_ALERT: !CARRIER_ALERT
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CARRIER_ALERT",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CBT_ALERT')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, CBT_ALERT)),
      onClick: function onClick() {
        return onSelect({
          CBT_ALERT: !CBT_ALERT
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CBT_ALERT",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('TK_ALERT')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, TK_ALERT)),
      onClick: function onClick() {
        return onSelect({
          TK_ALERT: !TK_ALERT
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "TK_ALERT",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.yellowErrorCodes'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CARRIER_CAUTION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, CARRIER_CAUTION)),
      onClick: function onClick() {
        return onSelect({
          CARRIER_CAUTION: !CARRIER_CAUTION
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CARRIER_CAUTION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CBT_CAUTION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, CBT_CAUTION)),
      onClick: function onClick() {
        return onSelect({
          CBT_CAUTION: !CBT_CAUTION
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CBT_CAUTION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('TK_CAUTION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, TK_CAUTION)),
      onClick: function onClick() {
        return onSelect({
          TK_CAUTION: !TK_CAUTION
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "TK_CAUTION",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.greenErrorCodes'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CARRIER_NOTIFICATION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, CARRIER_NOTIFICATION)),
      onClick: function onClick() {
        return onSelect({
          CARRIER_NOTIFICATION: !CARRIER_NOTIFICATION,
          CARRIER_INFORMATION: !CARRIER_NOTIFICATION
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CARRIER_NOTIFICATION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CBT_NOTIFICATION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, CBT_NOTIFICATION)),
      onClick: function onClick() {
        return onSelect({
          CBT_NOTIFICATION: !CBT_NOTIFICATION,
          CBT_INFORMATION: !CBT_NOTIFICATION
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CBT_NOTIFICATION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('TK_NOTIFICATION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, TK_NOTIFICATION)),
      onClick: function onClick() {
        return onSelect({
          TK_NOTIFICATION: !TK_NOTIFICATION,
          TK_INFORMATION: !TK_NOTIFICATION
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "TK_NOTIFICATION",
      className: "w-6 h-6"
    }));
  }))), hasPermissions(['module.filter.status.ebs']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.ebsStates"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h2", {
      className: "font-bold py-4 m-0"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.ebsErrorCodes'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.DTC_ALARM"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DTC_ALARM)),
      onClick: function onClick() {
        return onSelect({
          DTC_ALARM: !DTC_ALARM
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DtcAlarm, {
      status: "DTC_ALARM",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.DTC_CAUTION"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DTC_CAUTION)),
      onClick: function onClick() {
        return onSelect({
          DTC_CAUTION: !DTC_CAUTION
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DtcCaution, {
      status: "DTC_CAUTION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.DTC_NOTIFICATION"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline', 'ml-1', 'cursor-pointer', _defineProperty({}, _statusModule["default"].selectedStatus, DTC_NOTIFICATION)),
      onClick: function onClick() {
        return onSelect({
          DTC_NOTIFICATION: !DTC_NOTIFICATION
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DtcNotification, {
      status: "DTC_NOTIFICATION",
      className: "w-6 h-6"
    }));
  })))), !hideReset && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    className: "text-primary text-sm mt-2",
    onClick: function onClick() {
      onReset();
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.reset",
    tagName: "span"
  })));
};

exports.StatusView = StatusView;
StatusView.propTypes = {
  className: _propTypes["default"].string,
  hideReset: _propTypes["default"].bool,
  onSelect: _propTypes["default"].func,
  onReset: _propTypes["default"].func,
  hasPermissions: _propTypes["default"].func,
  states: _propTypes["default"].shape({
    NO_GPS: _propTypes["default"].bool,
    COUPLED: _propTypes["default"].bool,
    NOT_COUPLED: _propTypes["default"].bool,
    DRIVING: _propTypes["default"].bool,
    STANDING: _propTypes["default"].bool,
    LOADED: _propTypes["default"].bool,
    NOT_LOADED: _propTypes["default"].bool,
    DOOR_1_OPEN: _propTypes["default"].bool,
    DOOR_1_CLOSED: _propTypes["default"].bool,
    DOOR_2_OPEN: _propTypes["default"].bool,
    DOOR_2_CLOSED: _propTypes["default"].bool,
    DOOR_3_OPEN: _propTypes["default"].bool,
    DOOR_3_CLOSED: _propTypes["default"].bool,
    REEFER_ON: _propTypes["default"].bool,
    REEFER_OFF: _propTypes["default"].bool,
    NO_FUEL_RESERVE: _propTypes["default"].bool,
    FUEL_RESERVE: _propTypes["default"].bool,
    CARRIER_ALERT: _propTypes["default"].bool,
    CBT_ALERT: _propTypes["default"].bool,
    TK_ALERT: _propTypes["default"].bool,
    CARRIER_CAUTION: _propTypes["default"].bool,
    CBT_CAUTION: _propTypes["default"].bool,
    TK_CAUTION: _propTypes["default"].bool,
    CARRIER_NOTIFICATION: _propTypes["default"].bool,
    CBT_NOTIFICATION: _propTypes["default"].bool,
    TK_NOTIFICATION: _propTypes["default"].bool,
    DTC_ALARM: _propTypes["default"].bool,
    DTC_CAUTION: _propTypes["default"].bool,
    DTC_NOTIFICATION: _propTypes["default"].bool
  })
};

var noop = function noop() {};

StatusView.defaultProps = {
  className: '',
  hideReset: false,
  onSelect: noop,
  onReset: noop,
  hasPermissions: noop,
  states: _initialState["default"]
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(null)(StatusView);

exports["default"] = _default;